export default __webpack_public_path__ + "static/media/Close.af9bb104.svg";